import { IHub } from "../hub/hub";
import { IMeetingPointsEntityList } from "../transferCompany/transferCompany";

export interface IHubTender {
  id: number;
  hubId: number;
  hubName: string;
  fleetId: number;
  preferred: boolean;
  hub?: IHub;
  meetingPoints: IMeetingPointsEntityList
  journeysDistributionPercentage: number;
}

export interface IHubTenderParams {
  fleetId?: number;
  hubId?: number;
  preferred?: boolean;
}

export interface IHubTenderMatches {
  hubTenderId: number;
  fleetId: number;
  transferCompanyId: number;
  preferred: boolean;
  status: HubTenderMatchesStatusType;
}

export enum HubTenderMatchesStatusType {
  Matched = 'MATCHED',
  LockedForComplaints = 'LOCKED_FOR_COMPLAINTS',
  FleetNotAcceptingRides = 'FLEET_NOT_ACCEPTING_RIDES',
  NoMatchingVehicles = 'NO_MATCHING_VEHICLES',
  TravelAddonNotSupported = 'TRAVEL_ADDON_NOT_SUPPORTED',
  InactiveFleet = 'INACTIVE_FLEET',
  VehicleCategoryNotSupported = 'VEHICLE_CATEGORY_NOT_SUPPORTED',
}

export const HubTenderMatchesStatusTypeDisplayNames = {
  [HubTenderMatchesStatusType.Matched]: 'Matched',
  [HubTenderMatchesStatusType.LockedForComplaints]: 'Locked for complaints',
  [HubTenderMatchesStatusType.FleetNotAcceptingRides]: 'Fleet not accepting rides',
  [HubTenderMatchesStatusType.NoMatchingVehicles]: 'No matching vehicles',
  [HubTenderMatchesStatusType.TravelAddonNotSupported]: 'Travel addon not supported',
  [HubTenderMatchesStatusType.InactiveFleet]: 'Inactive fleet',
  [HubTenderMatchesStatusType.VehicleCategoryNotSupported]: 'Vehicle category not supported',
}
